export const getIsServer = (): boolean => typeof window === 'undefined'
export const getClient = (): boolean => !getIsServer()
export const getIsClientMobile = (): boolean => !getIsServer() && window.innerWidth <= 1023.98
